import {getReferringPage} from '@wix/wixstores-client-storefront-sdk';
import {RootStore} from '../RootStore';

export const fetchDeferredData = async (
  rootStore: RootStore,
  {
    referringPageId: pageId,
    referringPagePath: pagePath,
  }: {
    referringPageId?: string;
    referringPagePath?: string[];
  },
) => {
  if (pageId && pagePath) {
    return {
      referringPage: await getReferringPage(rootStore.wixCodeApi, {
        pageId,
        pagePath,
      }),
    };
  } else {
    return {};
  }
};
